const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  CHECKBOX: 'checkbox',
};

const INPUT_STYLE_TYPES = {
  DEFAULT: 'default',
  OUTLINED: 'outlined',
  FILLED: 'filled',
};

export { INPUT_TYPES, INPUT_STYLE_TYPES };
